import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/_project/bid-row-details/$projectId/$subProjectId/")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/bid-row-details/$projectId/$subProjectId/work-packages",
      params,
    });
  },
});
